export default {
    CONTENTSTRING: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'GREATER_THAN', label: '>' },
        { criteria: 'GREATER_THAN_OR_EQUAL', label: '>=' },
        { criteria: 'LESS_THAN', label: '<' },
        { criteria: 'LESS_THAN_OR_EQUAL', label: '<=' },
        { criteria: 'STARTS_WITH', label: 'Starts' },
        { criteria: 'ENDS_WITH', label: 'Ends' },
        { criteria: 'CONTAINS', label: 'Contains' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTBOOLEAN: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTCONTENT: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'GREATER_THAN', label: '>' },
        { criteria: 'GREATER_THAN_OR_EQUAL', label: '>=' },
        { criteria: 'LESS_THAN', label: '<' },
        { criteria: 'LESS_THAN_OR_EQUAL', label: '<=' },
        { criteria: 'STARTS_WITH', label: 'Starts' },
        { criteria: 'ENDS_WITH', label: 'Ends' },
        { criteria: 'CONTAINS', label: 'Contains' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTPASSWORD: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'GREATER_THAN', label: '>' },
        { criteria: 'GREATER_THAN_OR_EQUAL', label: '>=' },
        { criteria: 'LESS_THAN', label: '<' },
        { criteria: 'LESS_THAN_OR_EQUAL', label: '<=' },
        { criteria: 'STARTS_WITH', label: 'Starts' },
        { criteria: 'ENDS_WITH', label: 'Ends' },
        { criteria: 'CONTAINS', label: 'Contains' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTENCRYPTED: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'GREATER_THAN', label: '>' },
        { criteria: 'GREATER_THAN_OR_EQUAL', label: '>=' },
        { criteria: 'LESS_THAN', label: '<' },
        { criteria: 'LESS_THAN_OR_EQUAL', label: '<=' },
        { criteria: 'STARTS_WITH', label: 'Starts' },
        { criteria: 'ENDS_WITH', label: 'Ends' },
        { criteria: 'CONTAINS', label: 'Contains' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTDATETIME: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'GREATER_THAN', label: '>' },
        { criteria: 'GREATER_THAN_OR_EQUAL', label: '>=' },
        { criteria: 'LESS_THAN', label: '<' },
        { criteria: 'LESS_THAN_OR_EQUAL', label: '<=' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTNUMBER: [
        { criteria: 'EQUAL', label: '=' },
        { criteria: 'NOT_EQUAL', label: '<>' },
        { criteria: 'GREATER_THAN', label: '>' },
        { criteria: 'GREATER_THAN_OR_EQUAL', label: '>=' },
        { criteria: 'LESS_THAN', label: '<' },
        { criteria: 'LESS_THAN_OR_EQUAL', label: '<=' },
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTLIST: [
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
    CONTENTLISTPROPERTY: [
        { criteria: 'ALL_EQUAL', label: 'All Equal' },
        { criteria: 'ANY_EQUAL', label: 'Any Equal' },
    ],
    CONTENTOBJECT: [
        { criteria: 'IS_EMPTY', label: 'Empty' },
    ],
};
